/* eslint-disable react/style-prop-object */
import React, { useState, useEffect, useContext } from "react";
import Dropzone from "react-dropzone";
import AvatarEditor from "react-avatar-editor";
import Button from "../Button/Button";
import { popupcontext } from "../../../context/Popupscontext";
import { toast } from "react-toastify";
import trans from "../../../utils";

export default function ProfilePicture({ addData }) {
	const [undo, setUndo] = useState(false);
	let { picture, setPicture } = useContext(popupcontext);
	const defaultImage = `${process.env.PUBLIC_URL}/assets/Avatar.svg`; // Default image
	const [image, setImage] = useState(defaultImage); // Default to placeholder image

	// Function to handle file upload from Dropzone
	const handleDrop = async (acceptedFiles, rejectedFiles) => {
		// Check for rejected files
		if (rejectedFiles.length > 0) {
			toast.error(trans("Only JPEG, JPG, and PNG image formats are allowed."), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			return;
		}

		const file = acceptedFiles[0]; // Get the first uploaded file
		if (file) {
			try {
				// Update state and Formik field with the new file
				setImage(URL.createObjectURL(file)); // Set image preview using URL.createObjectURL
				addData.setFieldValue("picture", [file]); // Update Formik field with the file
			} catch (error) {
				toast.error(trans("Error uploading the image"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		}
	};

	// Function to handle deleting the uploaded photo
	const handleDelete = () => {
		setImage(defaultImage); // Reset to the default image
		setPicture(true);
		setUndo(true);
	};

	const handleUndo = () => {
		setImage(addData.values.picture); // Reset to the previous image
		setUndo(false);
		setPicture(false);
	};

	// Fetch local image on component mount (optional)
	useEffect(() => {
		setImage(addData.values.picture);
	}, [setImage, addData.values.picture]);

	const currentImage = () => {
		// Use the uploaded image if available, else fall back to the default image
		if (addData.values.picture?.length > 0) {
			return String(image); // Use the uploaded image URL
		}
		if (addData.values.picture === null) return defaultImage;
		return String(image); // Fallback to the default or previously set image
	};

	return (
		<div className="mb-24">
			<Dropzone
				onDrop={handleDrop}
				accept={{
					"image/jpeg": [],
					"image/png": [],
					"image/jpg": [],
				}} // Restrict accepted file types
				maxFiles={1} // Allow only one file
				multiple={false} // Disallow multiple files
			>
				{({ getRootProps, getInputProps, open }) => (
					<div className="text-center">
						<div {...getRootProps()} className="profile-picture-container">
							<AvatarEditor
								width={102}
								height={102}
								image={currentImage()} // Show the correct image based on the editing state and uploaded image
								border={0}
								className="profile-picture-container"
							/>
							<input {...getInputProps()} />
						</div>
						<div className="text-center mt-2">
							<Button
								htmlType="button"
								type={"primary"}
								text={trans("Upload Image")}
								onClick={open}
							/>
						</div>
						{!addData.values.picture === null ||
							((addData.values.picture?.length > 0 || undo) && (
								<div className="text-center mt-2">
									<Button
										type="default"
										danger={true}
										htmlType={"button"}
										text={undo ? trans("Undo Image") : trans("Delete Image")}
										onClick={undo ? handleUndo : handleDelete}
									/>
								</div>
							))}
					</div>
				)}
			</Dropzone>
		</div>
	);
}
